// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseDiffReport
 */
export interface ResponseDiffReport {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ResponseDiffReport
   */
  modifiedFields?: { [key: string]: string };
  /**
   *
   * @type {number}
   * @memberof ResponseDiffReport
   */
  opId?: number;
}

/**
 * Check if a given object implements the ResponseDiffReport interface.
 */
export function instanceOfResponseDiffReport(
  value: object,
): value is ResponseDiffReport {
  return true;
}

export function ResponseDiffReportFromJSON(json: any): ResponseDiffReport {
  return ResponseDiffReportFromJSONTyped(json, false);
}

export function ResponseDiffReportFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseDiffReport {
  if (json == null) {
    return json;
  }
  return {
    modifiedFields:
      json['modified_fields'] == null ? undefined : json['modified_fields'],
    opId: json['op_id'] == null ? undefined : json['op_id'],
  };
}

export function ResponseDiffReportToJSON(json: any): ResponseDiffReport {
  return ResponseDiffReportToJSONTyped(json, false);
}

export function ResponseDiffReportToJSONTyped(
  value?: ResponseDiffReport | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    modified_fields: value['modifiedFields'],
    op_id: value['opId'],
  };
}
